
/**
 * {string} selector
 * Selector of the element inside the message.
 * The element selection will be scoped to the message.
 * Ex: ".slaask-btn"
 *
 * {string} event
 * The event to listen.
 * It will be passed to the addEventListener function.
 * Ex: "click"
 *
 * {function} handler
 * The function to execute when the event is triggered.
 * @param  {Event} event
 * @return {Boolean}      Returning false means "failed interaction"
 *                        (prevents removeButtons)
 *
 * {boolean} removeButtons (optional)
 * Will remove every ".slaask-btn" elements from the message after the event
 * has been triggered.
 * Ex: true
 *
 * {function} printResponse (optional)
 * When the event is triggered, will make the visitor to send a message in the
 * chatbox. Useful when you ask the visitor to click on a button in the message,
 * and then make the response appear as a message.
 * Ex: event => event.currentTarget.innerHTML
 * @param  {Event} event
 * @return {string}      The text to be displayed as a message
 */
class Interaction {

  constructor(data) {
    if (typeof data.selector != 'string'
        || typeof data.event != 'string'
        || typeof data.handler != 'function') {
      Utils.log(data);
      throw "Invalid parameters. See printed paramters above.";
    }

    Utils.autoFeed(this, [
      "selector",
      "event",
      "handler",
      "removeButtons",
      "printResponse"
    ], data);
  }

}
